<template>
    <div id="main" class="app-main">
        <Header v-if="isRouterAlive && $route.fullPath.indexOf('english') === -1" />
        <router-view></router-view>
        <Footer v-if="$route.fullPath.indexOf('english') === -1"/>

        <div v-if="meiqia_open" class="meiqia_box">
            <div v-if="meiqia_stateS" class="meiqia_box_main">
                <ul>
                    <div>
                        <span  class="liuyan_text">免费十分钟法律咨询</span>
                    </div>
                    <div style="margin-top: 10px;">
                        <img src="./assets/liuyan/phone.png"/>
                        <span  class="liuyan_text">联系电话</span>
                    </div>
                    <div>
                        <!-- <span class="liuyan_text liuyan_c">010-84562288-629</span> -->
                        <p class="liuyan_text liuyan_c" style="margin-top: 20px;">周一</p>
                        <p class="liuyan_text liuyan_c">
                           永新<span style="padding:0 10px">薛燕</span>13811693119
                        </p>
                        <p class="liuyan_text liuyan_c" style="margin-top: 20px;">周二</p>
                        <p class="liuyan_text liuyan_c">
                            三友<span style="padding:0 10px">沈律师</span>13910776143
                        </p>
                        <p class="liuyan_text liuyan_c" style="margin-top: 20px;">周三</p>
                        <p class="liuyan_text liuyan_c">
                            万慧达<span style="padding:0 10px">李琛</span>15811541817
                        </p>
                        <p class="liuyan_text liuyan_c" style="margin-top: 20px;">周四</p>
                        <p class="liuyan_text liuyan_c">
                            集佳<span style="padding:0 10px">赵律师</span>13911168435
                        </p>
                        <p class="liuyan_text liuyan_c" style="margin-top: 20px;">周五</p>
                        <p class="liuyan_text liuyan_c">
                            京都<span style="padding:0 10px">靳律师</span>13810878247
                        </p>
                    </div>
                    <div style="text-align: center;">
                        <button class="subBtn" @click="openChats">在线咨询</button>
                    </div>
                </ul>
            </div>
            <div class="meiqia_left"  @click="closeMeiqia()" v-if="$route.fullPath.indexOf('english') === -1">
                <img src="./assets/liuyan/Group.png">
                <span>联<br>系<br>我<br>们</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/views/main-components/header';
    import Footer from '@/views/main-components/footer';
    import {userInfo} from "@/api/index";
    import util from '@/libs/util';
    import Cookies from "js-cookie";
    import {getStore} from "./libs/storage";
    import {addSaveVaileMessage} from '@/api/staticPage';
    import EventBus from "@/libs/eventBus"



    export default {
        components: {
            Header,
            Footer
        },
        provide () {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                header_show: true,
                footer_show: true,
                meiqia_state: false,
                meiqia_stateS: false,
                meiqia_open: true,
                scrollBtnFlag: false,
                isRouterAlive: true,
                msg:""
            };
        },
        created() {
            this.otherLogin();
            // this.uCenterLogin();
            EventBus.on('showContactUs',() => {
                _MEIQIA('init');
                _MEIQIA('showPanel');
            });
        },
        mounted() {
            //友盟-站长统计

            const script1 = document.createElement('script');
            script1.src = 'https://s4.cnzz.com/z_stat.php?id=1261139025&show=pic1';
            script1.language = 'JavaScript';
            document.body.appendChild(script1);
            const script2 = document.createElement('script');
            script2.src = 'https://c.cnzz.com/core.php?web_id=1261139025&show=pic1&t=z';
            script2.language = 'JavaScript';
            document.body.appendChild(script2);


            this.$nextTick(function () {
                //隐藏美洽客服按钮
                _MEIQIA('withoutBtn');
                // 初始化成功时的回调
                _MEIQIA('allSet', this.meiqiaCallBack);
                //创建美洽
                _MEIQIA('init');
            
            });


            window.addEventListener('scroll', this.scrollToTop)
        },
        destroyed() {
            window.removeEventListener('scroll', this.scrollToTop)
        },
        beforeDestroy() {
            EventBus.off('showContactUs');
        },
        watch: {
            '$route'() {
                if (window._czc) {
                    let location = window.location
                    let contentUrl = location.pathname + location.hash
                    let refererUrl = '/'
                    window._czc.push(['_trackPageview', contentUrl, refererUrl])
                }
            }
        },

        methods: {

            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            },

            /****************************接收token部分****************************/
            otherLogin() {
                let accessToken = util.getQueryString('data');

                if (accessToken && accessToken != '') {
                    this.setStore("accessToken", accessToken);

                    // 获取用户信息
                    userInfo().then(res => {
                        console.log("?????????????????????", res)
                        if (res.code == 200) {
                            // 避免超过大小限制
                            if (this.saveLogin) {
                                // 保存7天
                                Cookies.set("userInfo", JSON.stringify(res.result), {
                                    expires: 7
                                });
                            } else {
                                Cookies.set("userInfo", JSON.stringify(res.result));
                            }
                            this.setStore("userInfo", res.result);
                            let photo = res.result.photo ? res.result.photo : ''
                            this.$emit('childFn', photo);
                            this.$store.commit("setAvatarPath", photo);
                            // 加载菜单
                            util.initRouter(this);
                            this.$router.push({
                                name: "home_index",
                                // query:{
                                //     t:Date.now(),
                                // },
                            });
                            // this.closeLoginDialog()
                        } else {
                            this.loading = false;
                        }
                    });
                }


            },




            /****************************ucenter登录****************************/
            uCenterLogin() {
                let accessToken = getStore('accessToken');
                console.log(accessToken);
                if (!accessToken || accessToken == '') {

                    if (Cookies.get('accessToken') && Cookies.get('accessToken') != '') {
                        accessToken = Cookies.get('accessToken');
                        this.setStore("accessToken", accessToken);


                        // 获取用户信息
                        userInfo().then(res => {
                            console.log("?????????????????????", res)
                            if (res.code == 200) {
                                // 避免超过大小限制
                                if (this.saveLogin) {
                                    // 保存7天
                                    Cookies.set("userInfo", JSON.stringify(res.result), {
                                        expires: 7
                                    });
                                } else {
                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                }
                                this.setStore("userInfo", res.result);
                                let photo = res.result.photo ? res.result.photo : '';
                                this.$emit('childFn', photo);
                                this.$store.commit("setAvatarPath", photo);
                                // 加载菜单
                                util.initRouter(this);
                                this.reload();

                            } else {
                                this.loading = false;
                            }
                        });
                    }
                }
            },

            /****************************头部、尾部显示部分****************************/
            //是否显示头部
            header: function (bool) {
                this.header_show = bool;
            },

            //是否显示底部
            footer: function (bool) {
                this.footer_show = bool;
            },


            /****************************美洽部分****************************/
            //关闭美洽浮窗
            closeMeiqia() {

                this.meiqia_stateS = !this.meiqia_stateS;
                _MEIQIA('init');
            },

            //打开美洽聊天
            openChats() {
				_MEIQIA('showPanel');
                this.meiqia_stateS = !this.meiqia_stateS
			},
            //关闭美洽浮窗
			toggleMeiqia() {

				this.meiqia_open = !this.meiqia_open;
			},

            // 点击图片回到顶部方法，加计时器是为了过渡顺滑
            backTop() {
                let that = this;
                let timer = setInterval(() => {
                    let ispeed = Math.floor(-that.scrollTop / 5);
                    document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
                    if (that.scrollTop === 0) {
                        clearInterval(timer)
                    }
                }, 16)
            },

            // 为了计算距离顶部的高度，当高度大于200显示回顶部图标，小于200则隐藏
            scrollToTop() {
                let that = this;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                that.scrollTop = scrollTop;
                if (that.scrollTop > 200) {
                    that.scrollBtnFlag = true
                } else {
                    that.scrollBtnFlag = false
                }
            },

            //美洽初始化成功回调
            meiqiaCallBack() {
                this.meiqia_state = true;
            },
            /***********************留言**************************************/
            submitMsg(){
                let _this = this;
                let userInfo =Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                console.log('9999999',userInfo)
                if(userInfo==''){
                    toast('请登录后再操作',function(){
                        _this.$router.push({
                            path:'/index.html'
                        })
                    })
                    return false;
                }
                if(_this.msg==''){
                    toast('请输入留言内容')
                    return false
                }else if(_this.msg.length >100){
                    toast("留言字数过多，请保留在100字以内")
                    return false ;
                }
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    content:_this.msg,
                    name:userInfo && userInfo.nickName?userInfo.nickName:userInfo.name,
                    phone:userInfo && userInfo.mobilePhone
                }
                addSaveVaileMessage(params).then(res => {
                    console.log('--------------------',res)
                    if(res.code == 200){
                        toast('留言成功')
                        _this.msg = ''
                        _this.meiqia_open = false;
                    }
                })
            }

        }

    };
</script>

<style lang="less">
    html,
    body {
        width: 100%;
        height: 100%;
        background: #fff;
        /* overflow: hidden; */
    }

    .app-main {
        width: 100%;
        height: 100%;
    }

    .br button {
        margin-right: 5px;
    }

    .operation button {
        margin-right: 5px;
    }

    .ivu-btn-text:focus {
        box-shadow: none !important;
    }


    .meiqia_box {
        right: 0;
        top: 50%;
        position: fixed;
        overflow: hidden;
        margin-top: -200px;
        z-index: 999;


        .meiqia_left {
            width:28px;
            height:130px;
            background:rgba(18,18,16,1);
            border-radius:3px 0px 0px 3px;
            text-align: center;
            color: #fff;
            font-size: 13px;
            font-weight: 500;
            margin-top: 174px;
            margin-left: 5px;
            padding: 25px 7px 0 8px;
            box-sizing: border-box;
            line-height: 16px;
            cursor: pointer;
            float: left;
        }

        .meiqia_box_main {
            padding: 22px 20px;
            box-sizing: border-box;
            width: 230px;
            background:rgba(18,18,16,1);
            border-radius:4px 0px 0px 4px;
            /*text-align: center;*/
            float: left;
            .liuyan_text{
                margin-left: 9px;
                height:16px;
                font-size:13px;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:20px;
            }
            .liuyan_ta{
                width:165px;
                height:91px;
                background-color:rgba(46,46,46,1);
                border-radius: 4px;
                /*opacity:0.1;*/
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:18px;
                padding: 2px;
                outline: none;
            }
            .subBtn{
                width:161px;
                height:28px;
                background:rgba(255,255,255,1);
                font-size:12px;
                font-weight:400;
                color:rgba(18,18,16,1);
                line-height:18px;
                margin-top: 20px;
                border:none ;
                cursor: pointer;
                outline: none;
            }
            .liuyan_c{
                margin-top: 7px;
                display: flex;
                align-items: center;
                margin-left: 24px;
            }
        }

    }
</style>
